import { useQuery } from '@tanstack/react-query';
import { isAdministrator } from '@/lib/auth';

/**
 * Reads custom:appRole off the ID token. Cheap and local, but wrapped in a
 * query so callers get a loading state instead of a flash of the wrong UI.
 */
export function useIsAdministrator() {
  const query = useQuery({
    queryKey: ['is-administrator'],
    queryFn: isAdministrator,
    staleTime: Infinity,
  });
  return { ...query, isAdmin: query.data ?? false };
}
